import { connect } from 'react-redux';
import { Link } from 'react-router';

import useMartyContext from 'hooks/useMartyContext';
import { signupForRewards } from 'actions/account/rewards';

import css from 'styles/components/landing/vipOptIn.scss';

export const VipOptIn = props => {
  const { testId } = useMartyContext();
  const {
    signupForRewards,
    slotDetails,
    rewardsInfo
  } = props;

  if (!slotDetails || rewardsInfo?.consented) {
    return null;
  }

  const {
    enrollment = {},
    terms = {},
    supplemental = {},
    bgcolor
  } = slotDetails;

  const onSignup = e => {
    e.preventDefault();
    signupForRewards().then(resp => {
      // reload the page when enrollment has been dispatched to fetch new Symphony creatives on Dashboard
      if (resp?.transaction_type === 'ENROLL') {
        window.location.reload();
      }
    });
  };

  const styles = {
    background: bgcolor
  };

  return (
    <div className={css.container} style={styles}>
      <h2>{enrollment.heading}</h2>
      <p>{enrollment.copy}</p>
      <form method="post" onSubmit={onSignup}>
        <div className={css.termsCheckbox}>
          <input type="checkbox" id="rewardsTerms" required/>
          <label htmlFor="rewardsTerms">{terms.label}</label>
        </div>

        <Link to={terms.ctalink} data-test-id={testId('termsConditionsVip')}>{terms.cta}</Link>

        <div className={css.buttonRow}>
          <div className={css.signUpButton}>
            <button type="submit">{enrollment.cta}</button>
          </div>
          <div className={css.learnMoreButton}>
            <Link to={enrollment.secondaryctalink} data-test-id={testId('learnMoreVipButton')}>{enrollment.secondarycta}</Link>
          </div>
        </div>

        <Link
          to={supplemental.ctalink}
          data-track-action="Action"
          data-track-label="Loyalty"
          data-track-value="GotoQuestions"
          data-test-id={testId('vipFaqLink')}>
          {supplemental.cta}
        </Link>
      </form>
    </div>
  );
};

const mapStateToProps = state => {
  const { rewards: { rewardsInfo } } = state;

  return {
    rewardsInfo
  };
};

export default connect(mapStateToProps, {
  signupForRewards
})(VipOptIn);

